<script>
    import { createEventDispatcher } from 'svelte';
    import SpecEditor from './spec/SpecEditor.svelte';
    import ClaimsEditor from './claims/ClaimsEditor.svelte';
    import TermsPanel from '../terms/TermsPanel.svelte';
    import { termsStore } from '../../stores/termsStore.js';

    // Editor bindings that will be exposed to parent
    export let specEditor;
    export let claimsEditor;
    
    // Progress bar props to pass to SpecEditor
    export let progressVisible = false;
    export let progressStepsRemaining = 0;
    export let progressTotalSteps = 0;
    export let progressEstimatedTime = null;
    export let progressPercent = 0;
    
    const dispatch = createEventDispatcher();
    
    // Watch for when spec editor is ready
    $: if (specEditor) {
        dispatch('specEditorReady');
    }
    
    // Reactive z-index for terms panel when notification is showing
    $: isTermAddingMode = $termsStore.isTermAddingMode;
</script>

<div class="content">
    <div class="editor-panel spec-panel">
        <SpecEditor
            bind:editorView={specEditor}
            bind:progressVisible
            bind:progressStepsRemaining
            bind:progressTotalSteps
            bind:progressEstimatedTime
            bind:progressPercent
            on:stop
        />
    </div>
    <div class="editor-panel claims-panel">
        <ClaimsEditor bind:editorView={claimsEditor} />
    </div>
    <div class="editor-panel terms-panel" class:terms-panel-elevated={isTermAddingMode}>
        <TermsPanel />
    </div>
</div>

<style>
    .content {
        position: relative;
        display: flex;
        flex: 1;
        padding: var(--spacing-6) 0 0;
        gap: 15px;
        overflow: hidden;
        box-sizing: border-box;
    }

    .editor-panel {
        display: flex;
        flex-direction: column;
        min-width: 0;
        height: 100%;
        padding: var(--spacing-4);
        overflow: hidden;
        border-radius: var(--border-radius-3xl);
        transition: transform var(--duration-normal) var(--ease-in-out);
    }
    
    .spec-panel {
        overflow: visible;
    }

    .spec-panel {
        z-index: var(--z-index-10);
        flex: none;
        width: 38%;
        background-color: var(--color-bg-spec);
        border-radius: var(--border-radius-3xl);
    }

    .claims-panel {
        position: relative;
        z-index: var(--z-index-30);
        flex: none;
        width: 38%;
        overflow: hidden;
        background-color: var(--color-bg-claims);
        border-radius: var(--border-radius-3xl);
    }

    .terms-panel {
        z-index: var(--z-index-20);
        flex: 1;
        min-width: 20%;
        background-color: var(--color-bg-terms);
        border-radius: var(--border-radius-3xl);
    }
    
    /* Elevated state when notification is showing - higher than claims panel */
    .terms-panel-elevated {
        z-index: var(--z-index-40);
    }

    /* Classic theme borders for artboard look */
    :global([data-theme="classic"]) .spec-panel {
        border: 2px solid var(--color-spec-border);
    }

    :global([data-theme="classic"]) .claims-panel {
        border: 2px solid var(--color-claims-border);
    }

    /* ProseMirror needs global styles due to its dynamic nature */
    :global(.ProseMirror) {
        flex: 1;
        height: 100%;
        overflow-y: auto;
    }
</style>
